import React from "react";
import classNames from "classnames";

type TextInputProps = {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClick?: (e: React.MouseEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  placeholder?: string;
  disabled?: boolean;
  error?: string;
  className?: string;
};

const TextInput: React.FC<TextInputProps> = ({
  value,
  onChange,
  onClick,
  onKeyDown,
  placeholder = "Enter text...",
  disabled = false,
  error,
  className,
}) => {
  return (
    <>
      <input
        type="text"
        value={value}
        onChange={onChange}
        onClick={onClick}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        disabled={disabled}
        className={classNames("", {}, className)}
      />
      {error && <p className="mt-1 text-sm text-red-500">{error}</p>}
    </>
  );
};

export default TextInput;
